<template>
    <div>
        <div v-if="showSpecialityCount">
            <div class="specialities__count--line"></div>
            <p class="specialities__count--title">{{ $t('common.specialities.sub_specialities') }}</p>
            <p class="specialities__count">{{ specialities.length }}</p>
        </div>

        <div class="specialities">
            <ul ref="list" class="specialities__list">
                <li
                    v-for="speciality in specialities"
                    :key="speciality.subSpeciality.id"
                    ref="speciality"
                    class="specialities__speciality"
                >
                    <span>{{ getSubSpecialityName(speciality) }}</span>
                </li>
            </ul>

            <div
                v-if="moreCount > 0"
                class="specialities__more-indicator"
                @mouseover="isMoreToolitpOpen = true"
                @mouseleave="isMoreToolitpOpen = false"
            >
                <span>+ {{ moreCount }}</span>

                <common-dropdown :isOpen="isMoreToolitpOpen" arrowPositionY="top" arrowPositionX="right">
                    <ul class="specialities__list specialities__list--padded">
                        <li
                            v-for="speciality in specialities.slice(1)"
                            :key="speciality.subSpeciality.id"
                            class="specialities__speciality"
                        >
                            <span>{{ getSubSpecialityName(speciality) }}</span>
                        </li>
                    </ul>
                </common-dropdown>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            specialities: { type: Array, required: true, default: () => [] },
            showSpecialityCount: { type: Boolean, default: false },
        },

        data() {
            return {
                moreCount: 0,
                isMoreToolitpOpen: false,
            }
        },

        methods: {
            calculateMore() {
                this.$nextTick(() => {
                    const allSpecialities = this.$refs.speciality
                    const visibleSpecialities = []

                    if (!Array.isArray(allSpecialities)) {
                        return
                    }

                    for (const speciality of allSpecialities) {
                        if (speciality.offsetTop === 0) {
                            visibleSpecialities.push(speciality)
                        }
                    }

                    this.moreCount = allSpecialities.length - visibleSpecialities.length
                })
            },

            getSubSpecialityName(speciality) {
                return speciality.subSpeciality.name === 'General' ? speciality.speciality.name : speciality.subSpeciality.name
            },
        },

        watch: {
            moreCount(newValue, oldValue) {
                if (newValue !== oldValue) {
                    // Trigger recalculation again in case when text of "+ X"
                    // causes even more labels to hide.
                    this.calculateMore()
                }
            },

            specialities() {
                this.calculateMore()
            },
        },

        mounted() {
            this.calculateMore()
            window.addEventListener('resize', this.calculateMore)
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.calculateMore)
        },
    }
</script>
